import type { App } from '../../app/App';
import type { WinStreakDependencies } from '../winStreak/WinStreakController';
import type { EventCondition } from '../../app/state/events/types';
import { isConditionFulfilled } from '../../app/state/events/isEventConditionFulfilled';
import { ObservableValue } from '../../app/state/createObservableValue';
import { MetaPopupStackController } from '../../metaAbstractions/createMetaPopupController';
import type { ResourceMap } from '../../app/resources/types';

export function createWinStreakDependencies(app: App): WinStreakDependencies {
  return {
    isConditionMet(condition: EventCondition): boolean {
      return isConditionFulfilled(app.stateController, condition);
    },
    observable: new ObservableValue(app.stateController, [
      'levelIndex',
      'winStreakActiveEvent',
      'winStreakEventLastEndTime',
    ]),
    popupsController: new MetaPopupStackController(app.controller.popups),
    shareImage: app.platform.shareable
      ? async (imageBase64: Promise<string>): Promise<void> => {
          await app.platform.shareable?.share?.(await imageBase64);
        }
      : null,
    tracking: {
      onEventStart(eventId: string): void {
        app.tracking.trackEventStarted('WinStreak', eventId);
      },
      onEventFinished(eventId: string, progress: number): void {
        app.tracking.trackEventFinished({ type: 'WinStreak', eventId, progress });
      },
    },
    addResources: (resourceMap: ResourceMap, eventId: string): void => {
      app.resources.addWinStreakReward(resourceMap, eventId);
    },
  };
}
